import {useFirebaseAuth} from '@goschool/react-firebase'
import {useAuthenticationContext} from './AuthenticationContext'
import {useSignInContext} from './SignInContext'
import {useCallback} from 'react'
import {OAuthProvider, signInWithPopup} from 'firebase/auth'
import {IconButton} from '@mui/material'
import MicrosoftIcon from '@mui/icons-material/Microsoft'

export function MicrosoftSignInButton() {
  const {auth} = useFirebaseAuth()
  const {customConfigs, enabledMethods} = useAuthenticationContext()
  const {setState, handleError, handleSuccess, resetError} = useSignInContext()

  const signIn = useCallback(
    async () => {
      const provider = new OAuthProvider('microsoft.com')
      if ('microsoft.com' in customConfigs) {
        provider.setCustomParameters(customConfigs['microsoft.com'])
      }
      setState('pending')
      resetError()
      try {
        const credential = await signInWithPopup(auth, provider)
        await handleSuccess(credential)
      } catch (e) {
        handleError(e, 'microsoft')
        setState('failed')
      }
    }, [auth, customConfigs, handleSuccess, resetError, handleError, setState])

  if (!enabledMethods.includes('microsoft')) {
    return null
  }
  return <IconButton onClick={signIn}><MicrosoftIcon/></IconButton>
}
